import type { FileWebServiceInterface } from '@commons/bo-ui/form/file-picker/services/file.web-service.interface';

import { InjectionToken } from '@angular/core';

export const FILE_PICKER_SERVICE_TOKEN = new InjectionToken<FileWebServiceInterface>(
  'Service used to upload Wizbii file picker input'
);
